import { render, staticRenderFns } from "./UserDocument.vue?vue&type=template&id=4a4d7898&"
import script from "./UserDocument.vue?vue&type=script&lang=js&"
export * from "./UserDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports